// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-order .ant-modal-content {
  padding: 0 0px 13px 0 !important;
  border-radius: 12px;
}

.create-order .ant-modal-body {
  padding: 16px;
}

.create-order .ant-modal-footer {
  padding: 10px 20px;
}

.ccreate-order .ant-btn-primary {
  background-color: #040724 !important;
}

.create-order .ant-btn-disabled:hover {
  background-color: #040724 !important;
}

.custom-modal-header {
  color: white;
  background-color: #040724;
  padding: 10px 0px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin: 0;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.file-parent {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  min-width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 10px;

}
.file-parent2 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  min-width: 40%;
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 10px;

}

.file-container {
  display: flex;

  justify-content: flex-start;
  align-items: flex-end;
  min-width: 100%;

}

.react-editor{
  min-height: 300px!important;
}

.custom-radio-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  position: relative;

}

/* Hidden default radio input */
.custom-radio-input {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/page-components/Orders/OrderListTable.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,SAAS;EACT,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;;AAErB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;;EAEb,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;;AAEjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;;AAEpB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;AACf","sourcesContent":[".create-order .ant-modal-content {\n  padding: 0 0px 13px 0 !important;\n  border-radius: 12px;\n}\n\n.create-order .ant-modal-body {\n  padding: 16px;\n}\n\n.create-order .ant-modal-footer {\n  padding: 10px 20px;\n}\n\n.ccreate-order .ant-btn-primary {\n  background-color: #040724 !important;\n}\n\n.create-order .ant-btn-disabled:hover {\n  background-color: #040724 !important;\n}\n\n.custom-modal-header {\n  color: white;\n  background-color: #040724;\n  padding: 10px 0px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  margin: 0;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.file-parent {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n  min-width: 100%;\n  border: 1px solid #d9d9d9;\n  border-radius: 10px;\n\n}\n.file-parent2 {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n  min-width: 40%;\n  margin-top: 10px;\n  border: 1px solid #d9d9d9;\n  border-radius: 10px;\n\n}\n\n.file-container {\n  display: flex;\n\n  justify-content: flex-start;\n  align-items: flex-end;\n  min-width: 100%;\n\n}\n\n.react-editor{\n  min-height: 300px!important;\n}\n\n.custom-radio-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  position: relative;\n\n}\n\n/* Hidden default radio input */\n.custom-radio-input {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
